import {
  createAsyncThunk,
  createEntityAdapter,
  createReducer,
  createSelector,
  EntityState,
} from '@reduxjs/toolkit';

import Column from '@app/store/bulkRequest/form/Column';
import ColumnType from '@app/store/bulkRequest/form/ColumnType';
import { getBulkRequest } from '@app/store/bulkRequest/selectors';
import { getBulkRequestsForm } from '@app/store/transport-layer/bulk-request/bulk-requests/form';
import { RootState } from '@app/store/types';

export const fetchForm = createAsyncThunk(
  'bulkRequest/fetchForm',
  (vs: Parameters<typeof getBulkRequestsForm>) => getBulkRequestsForm(...vs)
);

export interface FormState {
  bulkRequestId: string | null;
  columns: EntityState<Column>;
  id: string | null;
}

const columnsEntityAdaptor = createEntityAdapter<Column>();

const initialState: FormState = {
  bulkRequestId: null,
  columns: columnsEntityAdaptor.getInitialState(),
  id: null,
};

export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(fetchForm.fulfilled, (_state, action): FormState => {
    const { id, columns, bulkRequestId } = action.payload;
    return {
      id,
      bulkRequestId,
      columns: columnsEntityAdaptor.setAll(columnsEntityAdaptor.getInitialState(), columns),
    };
  });
});

/**
 * 대량 전송 Form state를 반환합니다.
 */
const getForm = (state: RootState) => getBulkRequest(state).form;
const getColumns = (state: RootState) => getForm(state).columns;

const { selectAll, selectTotal } = columnsEntityAdaptor.getSelectors();

export const getColumnList = createSelector(getColumns, selectAll);

export const getColumnLength = createSelector(getColumns, selectTotal);

export const getRequesterInputTextColumns = createSelector(getColumnList, (columns) =>
  columns.filter((c) => c.type === 'FIELD_TEXT')
);

export const getColumnRequesterInputList = createSelector(getColumnList, (columns) =>
  columns.filter((column) => column.type === 'FIELD_CHECKBOX' || column.type === 'FIELD_TEXT')
);

export const getColumnByType = (state: RootState, props: { type: ColumnType }) =>
  getColumnList(state).find((column) => column.type === props.type);
